import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Crown, ArrowUpRight } from "lucide-react";

export function PlusGate({ toolName, tagline }) {
  return (
    <div className="relative overflow-hidden card-surface p-10 lg:p-14" data-testid="plus-gate">
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#D5FF3F]/10 blur-[120px] pointer-events-none" />
      <div className="relative max-w-2xl">
        <div className="inline-flex items-center gap-2 border border-[#D5FF3F]/30 bg-[#D5FF3F]/5 rounded-full px-3 py-1.5 mb-6">
          <Crown size={13} className="text-[#D5FF3F]" />
          <span className="text-xs font-mono uppercase tracking-widest text-[#D5FF3F]">
            Aura Plus only
          </span>
        </div>
        <h2 className="font-display text-5xl md:text-6xl leading-none mb-4">
          {toolName}
          <span className="text-[#D5FF3F]"> is on Plus.</span>
        </h2>
        <p className="text-[#A8ADA5] text-lg leading-relaxed max-w-lg mb-8">
          {tagline}
        </p>
        <div className="flex flex-wrap gap-3">
          <Link to="/app/pricing">
            <Button className="rounded-full btn-lime h-12 px-7">
              Upgrade to Plus · $77.77/mo <ArrowUpRight size={16} className="ml-1.5" />
            </Button>
          </Link>
          <Link to="/app">
            <Button className="rounded-full btn-outline h-12 px-7">
              Not now
            </Button>
          </Link>
        </div>
        <div className="mt-8 pt-8 border-t border-[#26282C] text-xs text-[#6D716C] font-mono uppercase tracking-widest">
          3-day full-refund window · Cancel any time
        </div>
      </div>
    </div>
  );
}
